import * as CONST from '../ActionTypes';

const initialState = {
  transactionList: [],
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    idFrom: '',
    idTo: '',
    customerName: '',
    priceFrom: '',
    priceTo: '',
    createdAtFrom: '',
    createdAtTo: '',
    isSubscription: '',
    productName: '',
    productIds: '',
    couponCode: '',
    payMethod: '',
    payStatus: '',
  },
  transaction: {},
  allTransactionList: [],
  csvTransactionListNew: [],
  countTransactionBySalespersonList: [],
  transactionBySalespersonList: [],
  allTransactionBySalespersonList: [],
  count: 0,
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  receipt: null,
  dataTransactionWithSalesperson: {},
};

function transaction(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 決済履歴一覧取得
    // -----------------
    case CONST.GET_TRANSACTION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          transactionList: action.payload,
        },
      );
    case CONST.GET_TRANSACTION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          transactionList: [],
        },
      );
    // -----------------
    // 決済履歴全件取得
    // -----------------
    case CONST.GET_ALL_TRANSACTION_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          allTransactionList: action.payload,
        },
      );
    case CONST.GET_ALL_TRANSACTION_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          allTransactionList: [],
        },
      );
    // -----------------
    //
    // -----------------
    case CONST.GET_COUNT_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          countTransactionBySalespersonList: action.payload,
        },
      );
    case CONST.GET_COUNT_TRANSACTION_LIST_BY_SALESPERSON_FAILURE:
      return Object.assign(
        {},
        state,
        {
          countTransactionBySalespersonList: [],
        },
      );
    // -----------------
    // 販売員ごとの決済履歴取得
    // -----------------
    case CONST.GET_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          transactionBySalespersonList: action.payload,
        },
      );
    case CONST.GET_TRANSACTION_LIST_BY_SALESPERSON_FAILURE:
      return Object.assign(
        {},
        state,
        {
          transactionBySalespersonList: [],
        },
      );
    // -----------------
    // 販売員ごとの全件決済履歴取得
    // -----------------
    case CONST.GET_ALL_TRANSACTION_LIST_BY_SALESPERSON_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          allTransactionBySalespersonList: action.payload,
        },
      );
    case CONST.GET_ALL_TRANSACTION_LIST_BY_SALESPERSON_FAILURE:
      return Object.assign(
        {},
        state,
        {
          allTransactionBySalespersonList: [],
        },
      );

    // -----------------
    // 決済履歴詳細取得
    // -----------------
    case CONST.GET_TRANSACTION_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          transaction: action.payload,
        },
      );
    case CONST.GET_TRANSACTION_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          transaction: {},
        },
      );
    // -----------------
    // 決済履歴全件取得(CSV用)
    // -----------------
    case CONST.GET_CSV_TRANSACTION_LIST_NEW_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          csvTransactionListNew: action.payload,
        },
      );
    case CONST.GET_CSV_TRANSACTION_LIST_NEW_FAILURE:
      return Object.assign(
        {},
        state,
        {
          csvTransactionListNew: [],
        },
      );
    // -----------------
    // 決済履歴件数取得
    // -----------------
    case CONST.GET_TRANSACTION_COUNT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          count: action.payload.count,
        },
      );
    case CONST.GET_TRANSACTION_COUNT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          count: 0,
        },
      );
    // -----------------
    // 決済取り消し(SBP)
    // -----------------
    case CONST.SBP_REFUND_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.SBP_REFUND_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 決済取り消し(UPC)
    // -----------------
    case CONST.UPC_REFUND_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.UPC_REFUND_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 決済取り消し(SBP PAYPAY)
    // -----------------
    case CONST.SBP_REFUND_PAYPAY_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.SBP_REFUND_PAYPAY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_REFUND_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    // -----------------
    // queryパラメータの設定
    // -----------------
    case CONST.SET_TRANSACTION_QUERY:
      return Object.assign(
        {},
        state,
        {
          query: Object.assign(
            {},
            state,
            action.payload,
          ),
        },
      );
    // -----------------
    // queryパラメータのクリア
    // -----------------
    case CONST.CLEAR_TRANSACTION_QUERY:
      return Object.assign(
        {},
        state,
        {
          searchParams: {
            createdAtFrom: '',
            createdAtTo: '',
            idFrom: '',
            idTo: '',
            priceFrom: '',
            priceTo: '',
            customerName: '',
            productName: '',
            productIds: '',
            couponCode: '',
            payMethod: '',
            payStatus: '',
          },
          sortParams: {
            createdAtAsc: false,
            idAsc: true,
            priceAsc: true,
            customerAsc: true,
          },
        },
      );
    // -----------------
    // 販売員ごとの決済履歴取得
    // -----------------
    case CONST.GET_TRANSACTION_LIST_BY_CUSTOMER_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          transactionList: action.payload,
        },
      );
    case CONST.GET_TRANSACTION_LIST_BY_CUSTOEMR_FAILURE:
      return Object.assign(
        {},
        state,
        {
          transactionList: [],
        },
      );
    // -----------------
    // 領収書作成
    // -----------------
    case CONST.GET_RECEIPT_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          receipt: action.payload,
        },
      );
    case CONST.GET_RECEIPT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          receipt: null,
        },
      );
    // -----------------
    // 領収書データクリア
    // -----------------
    case CONST.CLEAR_RECEIPT:
      return Object.assign(
        {},
        state,
        {
          receipt: null,
        },
      );
    // -----------------
    // 販売員毎の集計画面用
    // -----------------
    case CONST.GET_DATA_TRANSACTION_WITH_SALESPERSON_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          dataTransactionWithSalesperson: action.payload,
        },
      );
    case CONST.GET_DATA_TRANSACTION_WITH_SALESPERSON_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataTransactionWithSalesperson: {},
        },
      );

    default:
      return state;
  }
}

export default transaction;
